// @ts-expect-error MW_ENV injected by esbuild.
export default (MW_ENV || "DEV").toUpperCase() === "DEV"
